/**
 * @generated SignedSource<<ab08b5a467a0965e8381b332804175bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type LimitedCartDiscountConditionKindEnum = "ProductSelection";
import { FragmentRefs } from "relay-runtime";
export type limitedCartDiscountTable_LimitedCartDiscountFragment$data = {
  readonly conditions: ReadonlyArray<{
    readonly kind: LimitedCartDiscountConditionKindEnum;
  }>;
  readonly createdAt: string;
  readonly id: string;
  readonly isReductible: boolean;
  readonly productSelectionConfig: {
    readonly value?: number;
  };
  readonly title: string;
  readonly " $fragmentType": "limitedCartDiscountTable_LimitedCartDiscountFragment";
};
export type limitedCartDiscountTable_LimitedCartDiscountFragment$key = {
  readonly " $data"?: limitedCartDiscountTable_LimitedCartDiscountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"limitedCartDiscountTable_LimitedCartDiscountFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "limitedCartDiscountTable_LimitedCartDiscountFragment"
};

(node as any).hash = "240d10901cc914606cdc2ff5733d7985";

export default node;
